import * as Sentry from "@sentry/vue";
import {
  captureMonitoringException,
  captureMonitoringMessage,
  syncMonitoringScopeFromStorage,
  trackLocaleDiagnostics,
  trackMonitoringEvent,
} from "~/utils/monitoring";

export const useMonitoring = () => {
  return {
    trackEvent: trackMonitoringEvent,
    trackLocaleDiagnostics,
    captureException: captureMonitoringException,
    captureMessage: captureMonitoringMessage,
    syncScope: syncMonitoringScopeFromStorage,
    setTag: Sentry.setTag,
    setUser: Sentry.setUser,
    setContext: Sentry.setContext,
  };
};
